import React, { Component } from 'react';
import {
  Button,
  Card,
  Cascader,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Radio,
  Row,
  Select,
} from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import { queryMaterialDatabaseType } from '@api/administrative/material';
import { queryDeleteAttachment } from '@api/pub/attachment';
import CompanySearch from '@comm/companySearch';
import UploadFile from '@comm/upload/UploadFile';
import DrawerOther from '@comm/orgStructure/orgStructure';
import { BackBtn } from '@comm/BackBtn';
import SearchUser from '@comm/SearchUser';

const FormItem = Form.Item;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewTypes: [],
      delFiles: [],
      authorityMixes: [],
      documentType: [],
      checkedList: [
        { label: '全部', value: 0 },
        { label: '本公司人员', value: 1 },
        { label: '其他', value: 2 },
      ],
      views: [],
      DrawerVisible: false,
    };
  }

  // 获取资料类型
  getMaterialDatabaseType = databaseUuid => {
    queryMaterialDatabaseType({ databaseUuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          documentType: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  componentDidMount() {
    const { data, databaseInfo } = this.props;
    if (data && data.authorityMixes) {
      data.authorityMixes.map(item => {
        item.uid = item.uuid;
        return item;
      });
      this.setState({
        authorityMixes: data.authorityMixes,
      });
    }
    this.getMaterialDatabaseType(databaseInfo.uuid);
    this.setState({
      views: data ? data.views : databaseInfo.views,
      viewTypes: data ? data.viewTypes : databaseInfo.viewTypes,
    });
  }

  componentWillReceiveProps(nextProps) {
    const { data, databaseInfo } = nextProps;
    // const { authorityMixes } = this.state;
    // if (data && data.authorityMixes && authorityMixes.length === 0) {
    if (databaseInfo && databaseInfo.uuid !== this.props.databaseInfo.uuid) {
      databaseInfo &&
        this.setState({
          views: databaseInfo.views,
          viewTypes: databaseInfo.viewTypes,
        });
      this.getMaterialDatabaseType(databaseInfo.uuid);
    }

    if (data && data.uuid !== this.props.data.uuid) {
      data.authorityMixes &&
        data.authorityMixes.map(item => {
          item.uid = item.uuid;
          return item;
        });
      this.setState({
        authorityMixes: data.authorityMixes,
      });
      data &&
        this.setState({
          views: data.views,
          viewTypes: data.viewTypes,
        });
    }
  }

  // 其他权限选择
  checkedChange = list => {
    this.setState({
      viewTypes: list,
    });
  };

  checkedRadioChange = () => {};

  handleUserChange = (value, option) => {
    this.props.form.setFieldsValue({ renewalUserName: option.props.children });
  };
  /* ---------------------------------------------级联选择器--------------------------------------------------------------*/

  showLable = label => {
    const text = label[label.length - 1];
    return text;
  };

  // 获取资料目录arr
  formatArr = (arr, uuid) => {
    arr.map(item => {
      if (item.uuid === uuid) {
        this.defaultArr = item.valueArr;
      } else if (item.children && item.children.length > 0) {
        this.formatArr(item.children, uuid);
      }

      return item;
    });
  };

  // 设置资料目录列表
  formatOption = (obj, arr) => {
    arr.map(item => {
      item.value = item.uuid;
      item.label = item.name;
      if (obj === '') {
        item.valueArr = [item.uuid];
      } else {
        const newValueArr = obj.valueArr.slice(0);
        newValueArr.push(item.uuid);
        item.valueArr = newValueArr;
      }
      if (item.children && item.children.length > 0) {
        this.formatOption(item, item.children);
      }
      return item;
    });
  };

  // 获取资料目录名称
  formatName = (arr, uuid) => {
    arr.map(item => {
      if (item.uuid === uuid) {
        this.directory = item.name;
      } else if (item.children && item.children.length > 0) {
        this.formatName(item.children, uuid);
      }

      return item;
    });
  };

  /* ---------------------------------------------级联选择器结束-----------------------------------------------------------*/
  handleCompanyChange = (value, option) => {
    this.props.form.setFieldsValue({
      company: option.props.children,
    });
  };

  /* --------------- 其他权限详情---------------------------*/
  showDrawer = () => {
    this.setState({
      DrawerVisible: true,
    });
  };

  closeDrawer = () => {
    this.setState({
      DrawerVisible: false,
    });
  };

  setViews = views => {
    this.setState({ views });
  };

  /* --------------- 其他权限详情结束------------------------*/
  // 文件删除
  fileRemove = file => {
    const { delFiles } = this.state;
    delFiles.push(file);
    this.setState({ delFiles });
  };

  // 提交
  submit = e => {
    const { data, databaseInfo, userList, directoryList } = this.props;
    const { authorityMixes, views } = this.state;
    if (e) {
      e.preventDefault();
    }
    this.props.form.validateFields((err, value) => {
      if (!err) {
        const params = data ? { ...data } : {};

        data && data.uuid && (params.uuid = data.uuid);
        params.name = value.name;
        params.no = value.no;
        params.databaseUuid = databaseInfo.uuid;
        params.database = databaseInfo.name;
        params.directoryUuid = value.directoryUuid[value.directoryUuid.length - 1];
        this.formatName(directoryList, params.directoryUuid);
        params.directory = this.directory;
        params.companyUuid = value.companyUuid;
        params.company = value.company;
        params.type = value.type;
        params.beginDate = value.beginDate ? value.beginDate.format('YYYY-MM-DD') : null;
        params.endDate = value.endDate ? value.endDate.format('YYYY-MM-DD') : null;
        params.manager = databaseInfo.manager;
        params.managerUuid = databaseInfo.managerUuid;
        params.amount = value.amount;
        params.number = value.number;
        params.status = value.status;
        params.isRenewal = value.isRenewal;
        if (value.isRenewal) {
          params.renewalUserUuid = value.renewalUserUuid;
          params.renewalUserName = value.renewalUserName;
          params.renewalReminderDate = value.renewalReminderDate
            ? value.renewalReminderDate.format('YYYY-MM-DD')
            : null;
        } else {
          params.renewalUserUuid = null;
          params.renewalUserName = null;
          params.renewalReminderDate = null;
        }

        params.viewTypes = value.viewTypes;
        params.views = views;
        authorityMixes.map(item => {
          item.mixUuid = value[`mixUuid${item.uid}`];
          userList.map(it => {
            if (it.uuid === item.mixUuid) {
              item.mixName = it.name;
            }
            return it;
          });
          value[`limitCount${item.uid}`] && (item.limitCount = value[`limitCount${item.uid}`]);
          value[`maturityDate${item.uid}`] &&
            (item.maturityDate = value[`maturityDate${item.uid}`].format('YYYY-MM-DD'));
          return item;
        });
        params.authorityMixes = JSON.parse(JSON.stringify(authorityMixes));
        params.authorityMixes.map(item => {
          delete item.uid;
          return item;
        });
        params.files = value.files;
        params.remark = value.remark;

        this.props.handSubmit(params);
        if (this.state.delFiles.length > 0) {
          this.state.delFiles.map(item => {
            queryDeleteAttachment({
              uuid: item.uuid,
            }).then(() => {});
            return item;
          });
        }
      }
    });
  };

  /** --------------------------临时权限增加-------------------------------------------------*/
  addAuthorityMixesItem = () => {
    const { authorityMixes } = this.state;
    const item = {
      uid: Date.now(),
    };
    authorityMixes.push(item);
    this.setState({ authorityMixes });
  };

  delAuthorityMixes = uid => {
    let { authorityMixes } = this.state;
    authorityMixes = authorityMixes.filter(item => item.uid !== uid);
    this.setState({ authorityMixes });
  };

  authorityMixesItem = item => {
    const { getFieldDecorator } = this.props.form;
    const { userList } = this.props;
    return (
      <Row>
        <Col span={7}>
          <FormItem style={{ marginBottom: '0' }}>
            {getFieldDecorator(`mixUuid${item.uid}`, {
              rules: [{ required: true, message: '请选择目标' }],
              initialValue: item.mixUuid || [],
            })(
              <Select
                showSearch
                placeholder="选择目标"
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {userList
                  ? userList.map(user => {
                      return (
                        <Select.Option key={user.uuid} value={user.uuid}>
                          {user.name}
                        </Select.Option>
                      );
                    })
                  : null}
              </Select>,
            )}
          </FormItem>
        </Col>
        <Col span={1} />
        <Col span={4} style={{ paddingLeft: '10px' }}>
          <FormItem>
            {getFieldDecorator(`limitCount${item.uid}`, {
              initialValue: item.limitCount,
            })(<InputNumber style={{ width: '100%' }} placeholder="请设置次数" />)}
          </FormItem>
        </Col>
        <Col span={4} style={{ paddingLeft: '10px' }}>
          <FormItem>
            {item.maturityDate
              ? getFieldDecorator(`maturityDate${item.uid}`, {
                  initialValue: moment(item.maturityDate),
                })(<DatePicker />)
              : getFieldDecorator(`maturityDate${item.uid}`)(<DatePicker />)}
          </FormItem>
        </Col>
        <Col span={1} />
        <Col span={3}>
          <a onClick={() => this.delAuthorityMixes(item.uid)}>删除</a>
        </Col>
      </Row>
    );
  };

  /**---------------------------------------------------------------------------------------*/

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { data = {}, databaseInfo, directoryUuid, directoryList, isSubmitting } = this.props;
    const { viewTypes, DrawerVisible, checkedList, documentType, views } = this.state;
    const { authorityMixes } = this.state;
    const formItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 15 },
    };
    const formItemLayout2 = {
      labelCol: { span: 2 },
      wrapperCol: { span: 15 },
    };
    const dataViews = [];
    const databaseInfoViews = [];
    this.formatOption('', directoryList);
    this.formatArr(directoryList, data.directoryUuid ? data.directoryUuid : directoryUuid);
    data.views &&
      data.views.map(item => {
        dataViews.push(item.uuid);
        return item;
      });
    databaseInfo.views &&
      databaseInfo.views.map(item => {
        databaseInfoViews.push(item.uuid);
        return item;
      });
    getFieldDecorator('company');

    getFieldDecorator(`renewalUserName`, {
      initialValue: data.renewalUserName,
    });

    return (
      <div>
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
          <Button
            icon="upload"
            type="primary"
            style={{ marginRight: 10 }}
            onClick={this.submit}
            loading={isSubmitting}
          >
            提交
          </Button>
        </div>
        <Form>
          <Card title="基本信息" style={{ marginTop: '16px' }}>
            <Row>
              <Col span={12}>
                <FormItem label="资料名称" {...formItemLayout}>
                  {getFieldDecorator('name', {
                    rules: [{ required: true, message: '请填写资料名称' }],
                    initialValue: data.name || null,
                  })(<Input />)}
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem label="资料编号" {...formItemLayout}>
                  {getFieldDecorator('no', {
                    initialValue: data.no || null,
                  })(<Input />)}
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <FormItem label="归属目录" {...formItemLayout}>
                  {getFieldDecorator('directoryUuid', {
                    rules: [{ required: true, message: '请选择归属目录' }],
                    initialValue: this.defaultArr,
                  })(
                    <Cascader
                      options={directoryList}
                      changeOnSelect
                      placeholder="请选择归属目录"
                      displayRender={this.showLable}
                    />,
                  )}
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem label="归属公司" {...formItemLayout}>
                  {getFieldDecorator('companyUuid', {
                    rules: [{ required: true, message: '请选择归属公司' }],
                    initialValue: data.companyUuid,
                  })(
                    <CompanySearch
                      companyName={data.company}
                      companyUuid={data.companyUuid}
                      onChange={this.handleCompanyChange}
                      {...this.props}
                    />,
                  )}
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span={12}>
                <FormItem label="归属资料库" {...formItemLayout}>
                  <span>{databaseInfo.name || null}</span>
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem label="资料类型" {...formItemLayout}>
                  {getFieldDecorator('type', {
                    rules: [{ required: true, message: '请选择资料类型' }],
                    initialValue: data.type ? data.type : null,
                  })(
                    <Select>
                      {documentType.map(item => {
                        return (
                          <Select.Option value={item.name} key={item.name}>
                            {item.name}
                          </Select.Option>
                        );
                      })}
                    </Select>,
                  )}
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span={12}>
                <FormItem label="资料周期" {...formItemLayout}>
                  {data.beginDate
                    ? getFieldDecorator('beginDate', {
                        initialValue: moment(data.beginDate),
                      })(<DatePicker style={{ width: '45%' }} />)
                    : getFieldDecorator('beginDate')(<DatePicker style={{ width: '45%' }} />)}
                  <span>--</span>
                  {data.endDate
                    ? getFieldDecorator('endDate', {
                        initialValue: moment(data.endDate),
                      })(<DatePicker style={{ width: '45%' }} />)
                    : getFieldDecorator('endDate')(<DatePicker style={{ width: '45%' }} />)}
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem label="资料状态" {...formItemLayout}>
                  {getFieldDecorator('status', {
                    rules: [{ required: true, message: '请选择资料状态' }],
                    initialValue: data.status || 1,
                  })(
                    <Radio.Group>
                      <Radio value={1}>有效</Radio>
                      <Radio value={2}>失效</Radio>
                    </Radio.Group>,
                  )}
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <FormItem label="总量" {...formItemLayout}>
                  {getFieldDecorator('amount', {
                    rules: [{ required: true, message: '请填写总量' }],
                    initialValue: data.amount || null,
                  })(<InputNumber />)}
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem label="库存" {...formItemLayout}>
                  {getFieldDecorator('number', {
                    rules: [{ required: true, message: '请填写库存' }],
                    initialValue: data.number || null,
                  })(<InputNumber />)}
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <FormItem label="管理人员" {...formItemLayout}>
                  <span>{databaseInfo.manager || null}</span>
                </FormItem>
              </Col>
            </Row>
          </Card>
          <Card title="续证配置">
            <Row>
              <Col span={8}>
                <FormItem label="是否续证" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                  {getFieldDecorator('isRenewal', {
                    rules: [{ required: true, message: '请选择是否续证' }],
                    initialValue: data.isRenewal || false,
                  })(
                    <Radio.Group
                      options={[
                        { value: false, label: '否' },
                        { value: true, label: '是' },
                      ]}
                      onChange={this.checkedRadioChange}
                    />,
                  )}
                </FormItem>
              </Col>

              {getFieldValue('isRenewal') && (
                <Col span={8}>
                  <FormItem label="续证经办人" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    {getFieldDecorator('renewalUserUuid', {
                      rules: [{ required: true, message: '请选择续证经办人' }],
                      initialValue: data.renewalUserUuid,
                    })(<SearchUser onChange={this.handleUserChange} />)}
                  </FormItem>
                </Col>
              )}
              {getFieldValue('isRenewal') && (
                <Col span={8}>
                  <FormItem label="续证提醒时间" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    {getFieldDecorator('renewalReminderDate', {
                      rules: [{ required: true, message: '请选择续证提醒时间' }],
                      initialValue: data.renewalReminderDate
                        ? moment(data.renewalReminderDate)
                        : null,
                    })(<DatePicker />)}
                  </FormItem>
                </Col>
              )}
            </Row>
          </Card>
          <Card title="权限控制">
            <Row>
              <Col span={8}>
                <FormItem label="长期权限" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                  {getFieldDecorator('viewTypes', {
                    rules: [{ required: true, message: '请选择长期权限' }],
                    initialValue: data.viewTypes || databaseInfo.viewTypes,
                  })(<Checkbox.Group options={checkedList} onChange={this.checkedChange} />)}
                </FormItem>
              </Col>
              <Col span={6}>
                {viewTypes && viewTypes.some(item => item === 2) ? (
                  <FormItem style={{ marginBottom: '0' }}>
                    <a onClick={this.showDrawer} style={{ whiteSpace: 'nowrap' }}>
                      其他权限详情
                    </a>
                  </FormItem>
                ) : null}
              </Col>
            </Row>
            <Row>
              <FormItem label="临时权限" {...formItemLayout2}>
                {authorityMixes.map(item => this.authorityMixesItem(item))}
                <Button
                  style={{ width: '100%', borderStyle: 'dashed' }}
                  onClick={this.addAuthorityMixesItem}
                >
                  +添加临时权限
                </Button>
              </FormItem>
            </Row>
          </Card>
          <Card title="资料附件">
            <FormItem label="资料附件" labelCol={{ span: 2 }} wrapperCol={{ span: 5 }}>
              {getFieldDecorator('files', {
                rules: [{ required: true, message: '请上传资料附件' }],
                initialValue: data.files || [],
              })(
                <UploadFile
                  type="ghost"
                  fileList={data.file}
                  onRemove={this.fileRemove}
                  isPreview
                />,
              )}
            </FormItem>
            <FormItem label="备注说明" {...formItemLayout2}>
              {getFieldDecorator('remark', {
                initialValue: data.remark || null,
              })(
                <Input.TextArea
                  placeholder="备注"
                  type="textarea"
                  autosize={{ minRows: 3, maxRows: 9 }}
                  maxLength={1000}
                />,
              )}
              <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
            </FormItem>
            <Row>
              <Col span={12}>
                <FormItem label="入库人员" {...formItemLayout}>
                  {getFieldDecorator('crName', {
                    initialValue: data.createUserName,
                  })(<span>{this.props.accountInfo.userName}</span>)}
                </FormItem>
              </Col>
              <Col span={12}>
                {/* <FormItem label="入库时间" {...formItemLayout}>
                  {getFieldDecorator("crTime", {
                    initialValue: data.createUserName
                  })(<span>{moment(Date.now()).format("YYYY-MM-DD")}</span>)}
                </FormItem> */}
              </Col>
            </Row>
          </Card>
        </Form>

        {DrawerVisible ? (
          <DrawerOther
            onClose={this.closeDrawer}
            visible={DrawerVisible}
            views={views}
            setViews={this.setViews}
          />
        ) : null}
      </div>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Form.create()(BaseForm));



// WEBPACK FOOTER //
// ./src/components/administrative/material/document/FormBase.js